module.exports = __webpack_public_path__ + "assets/img/Ic-Mosgram.8f49e609.png";